var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4117 14.7489C11.7371 15.0837 12.2655 15.0837 12.5909 14.7489L16.756 10.4642C17.0813 10.1294 17.0813 9.58581 16.756 9.25106C16.4306 8.91631 15.9021 8.91631 15.5767 9.25106L12 12.9306L8.42327 9.25374C8.09788 8.91899 7.56944 8.91899 7.24405 9.25374C6.91865 9.58848 6.91865 10.1321 7.24405 10.4669L11.4091 14.7516L11.4117 14.7489Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIco);
export default __webpack_public_path__ + "static/media/Expand_ico.6752cb64691ccd9118f033d1d34b2a37.svg";
export { ForwardRef as ReactComponent };